/**
 * «Hoy en el club»: lo pendiente y las cuatro cifras · 13-10-2026
 *
 * Una sola consulta para la campana de la cabecera, la franja de lo urgente y la
 * pantalla de Inicio. Se refresca cada cinco minutos y **al navegar si tiene más de
 * medio minuto**: firmas el contrato, vuelves y la campana ya no lo cuenta.
 */
import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useRouterState } from '@tanstack/react-router';
import { api } from '@/shared/api/client';
import { aProblema, ErrorDeApi } from '@/shared/api/errores';
import type { HoyDelClub } from '@/club/pendientes';

export const claveDeHoy = (club: string | null) => ['hoy', club] as const;

export function useHoy(club: string | null, activo: boolean) {
  const camino = useRouterState({ select: (s) => s.location.pathname });

  const consulta = useQuery({
    queryKey: claveDeHoy(club),
    enabled: Boolean(club) && activo,
    staleTime: 30_000,
    refetchInterval: 5 * 60_000,
    queryFn: async () => {
      const { data, error } = await api.v1.clubs({ club: club! }).today.get();
      if (error) throw new ErrorDeApi(aProblema(error));
      return data as unknown as HoyDelClub;
    },
  });

  // Al cambiar de pantalla, si lo que hay es de hace más de medio minuto. Tras
  // refrescar, `dataUpdatedAt` es de ahora y la condición no se cumple: no hay bucle.
  const { refetch, dataUpdatedAt } = consulta;
  useEffect(() => {
    if (dataUpdatedAt && Date.now() - dataUpdatedAt > 30_000) void refetch();
  }, [camino, refetch, dataUpdatedAt]);

  return consulta;
}
